export const GROUP_LIST_ACTION = "GROUP_LIST_ACTION";
export const GROUP_LIST_SUCCESS = "GROUP_LIST_SUCCESS";
export const GROUP_CREATE_ACTION = "GROUP_CREATE_ACTION";
export const GROUP_CREATE_SUCCESS = "GROUP_CREATE_SUCCESS";
export const GROUP_CREATE_FAIL = "GROUP_CREATE_FAIL";
export const GROUP_DELETE_ACTION = "GROUP_DELETE_ACTION";
export const GROUP_CLONE_ACTION = "GROUP_CLONE_ACTION";
export const GROUP_CLONE_SUCCESS = "GROUP_CLONE_SUCCESS";
export const GROUP_DELETE_SUCCESS = "GROUP_DELETE_SUCCESS";
export const GROUP_GET_UPDATE_ACTION = "GROUP_GET_UPDATE_ACTION";
export const GROUP_GET_UPDATE_SUCCESS = "GROUP_GET_UPDATE_SUCCESS";
export const GROUP_UPDATE_ACTION = "GROUP_UPDATE_ACTION";
export const GROUP_UPDATE_SUCCESS = "GROUP_UPDATE_SUCCESS";
export const GROUP_IMPORT_ACTION = "GROUP_IMPORT_ACTION";
export const GROUP_EXPORT_ACTION = "GROUP_EXPORT_ACTION";
export const GROUP_EXPORT_SUCCESS = "GROUP_EXPORT_SUCCESS";

export const GROUP_EXPORT_PRODUCT_FEED_ACTION = "GROUP_EXPORT_PRODUCT_FEED_ACTION";
export const GROUP_EXPORT_PRODUCT_FEED_SUCCESS = "GROUP_EXPORT_PRODUCT_FEED_SUCCESS";

export const GROUP_REINDEX_PRODUCT_ACTION = 'GROUP_REINDEX_PRODUCT_ACTION';
export const GROUP_REINDEX_PRODUCT_SUCCESS = 'GROUP_REINDEX_PRODUCT_SUCCESS';

export const GROUP_LIST_ALL_ACTION = "GROUP_LIST_ALL_ACTION";
export const GROUP_LIST_ALL_SUCCESS = "GROUP_LIST_ALL_SUCCESS";
export const GROUP_EXPORT_VOUCHER_ACTION = "GROUP_EXPORT_VOUCHER_ACTION";

export const GROUP_CREATE_TRANSLATE_ACTION = "GROUP_CREATE_TRANSLATE_ACTION";
export const GROUP_CREATE_TRANSLATE_SUCCESS = "GROUP_CREATE_TRANSLATE_SUCCESS";

export const GROUP_UPDATE_TRANSLATE_ACTION = "GROUP_UPDATE_TRANSLATE_ACTION";
export const GROUP_UPDATE_TRANSLATE_SUCCESS = "GROUP_UPDATE_TRANSLATE_SUCCESS";

export const GROUP_DELETE_TRANSLATE_ACTION = "GROUP_DELETE_TRANSLATE_ACTION";
export const GROUP_DELETE_TRANSLATE_SUCCESS = "GROUP_DELETE_TRANSLATE_SUCCESS";

export const GROUP_RESET = "GROUP_RESET";
export const GROUP_FAIL = "GROUP_FAIL";